import React from "react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function CookieBanner() {
  const { shouldShowBanner, setConsent } = useCookieConsent();

  if (!shouldShowBanner) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      className="fixed bottom-0 left-0 right-0 z-[100] border-t border-gray-200 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
    >
      <div className="container-app mx-auto flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <div className="min-w-0 flex-1">
          <h2 id="cookie-banner-title" className="text-sm font-semibold text-gray-900">
            Cookie-Einstellungen
          </h2>
          <p id="cookie-banner-desc" className="mt-1 text-sm text-gray-600">
            Wir verwenden Cookies, um die Website nutzerfreundlich zu gestalten und die Funktionalität zu gewährleisten.
            Sie können alle Cookies akzeptieren oder nur essentielle Cookies zulassen. Weitere Informationen finden Sie in unserer{" "}
            <Link
              to="/medical/datenschutz"
              className="font-medium text-gray-900 underline underline-offset-2 hover:no-underline"
            >
              Datenschutzerklärung
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() => setConsent("rejected")}
            className="rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50"
          >
            Nur notwendige
          </button>
          <button
            type="button"
            onClick={() => setConsent("accepted")}
            className="rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-gray-800"
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
